
import React from 'react';
import { Editor } from '@tiptap/react';
import { AlignLeft, AlignCenter, AlignRight, AlignJustify } from 'lucide-react';
import EditorButton from '../buttons/EditorButton';
import EditorButtonGroup from '../buttons/EditorButtonGroup';

interface AlignmentButtonsProps {
  editor: Editor;
}

const AlignmentButtons = ({ editor }: AlignmentButtonsProps) => {
  return (
    <EditorButtonGroup>
      <EditorButton 
        onClick={() => editor.chain().focus().setTextAlign('left').run()}
        isActive={editor.isActive({ textAlign: 'left' })}
        title="Aligner à gauche"
        icon={<AlignLeft className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().setTextAlign('center').run()}
        isActive={editor.isActive({ textAlign: 'center' })}
        title="Centrer"
        icon={<AlignCenter className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().setTextAlign('right').run()}
        isActive={editor.isActive({ textAlign: 'right' })}
        title="Aligner à droite"
        icon={<AlignRight className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().setTextAlign('justify').run()}
        isActive={editor.isActive({ textAlign: 'justify' })}
        title="Justifier"
        icon={<AlignJustify className="h-4 w-4" />}
      />
    </EditorButtonGroup>
  );
};

export default AlignmentButtons;
